import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth.service';
import { FullModeService } from 'src/app/services/full-mode.service';
import { LxcContainerService } from 'src/app/services/lxc-container.server';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StripeCheckoutRequest, StripePaymentService } from 'src/app/services/stripe-payment.service';
import { ServersService } from 'src/app/services/servers.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-plan',
  templateUrl: './plan.component.html',
  styleUrls: ['./plan.component.scss'],
})
export class PlanComponent implements OnInit {
  isLoading = false;
  isYearly = false;
  nav:any;
  canOrderFree: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  canOrderFreeServer: boolean = true;
  currentPlanType: string = '';
  titleSectionProp: any = {
    class: 'text-center iq-title-box-2',
    title: 'DATABASE_HOSTING',
    titleIcon: ''
  };

  appPrice:any={};
  currency:string='EUR'
  cloudITDepartment:any={
    title:'CLOUD_IT_DEPARTMENT',
    type:[
      {
        typeName:'FREE',
        price:'PRICE_FREE_CLOUD_IT_DEPARTMENT',
        currency:this.currency,
        description:'CLOUD_IT_DEPARTMENT_FREE_DESCRIPTION',
        plan_desc:'',
        additionalInfo:[
          { title:'CLOUD_IT_DEPARTMENT_FREE_INFO1', style:'service-text' },
          { title:'CLOUD_IT_DEPARTMENT_FREE_INFO4', style:'service-text' },
          { title:'CLOUD_IT_DEPARTMENT_FREE_INFO2', style:'service-text' },
          { title:'CLOUD_IT_DEPARTMENT_FREE_INFO3', style:'service-text' },
          { title:'CLUSTER_HOSTING_ULTIMATE_INFO3', style:'service-text' }
        ],
        downloadOrPay:"PAY"
      },
    {
      typeName:'PREMIUM',
      price:'PRICE_PREMIUM_CLOUD_IT_DEPARTMENT',
      priceValue:this.isYearly ? 57 : 99,
      currency:this.currency,
      description:'CLOUD_IT_DEPARTMENT_PREMIUM_DESCRIPTION',
      plan_desc:'',
      additionalInfo:[
        { title:'PRICING_ADDITIONAL', style:'service-text-bold' },
        { title:'CLOUD_IT_DEPARTMENT_PREMIUM_INFO1', style:'service-text' },
        { title:'CLOUD_IT_DEPARTMENT_PREMIUM_INFO2', style:'service-text asterisk-text' },
        { title:'CLOUD_IT_DEPARTMENT_PREMIUM_INFO3', style:'service-text double-asterisk-text' },
        { title:'CLUSTER_HOSTING_ULTIMATE_INFO2', style:'service-text' },
        { title:'CLOUD_IT_DEPARTMENT_PREMIUM_INFO4', style:'service-text third-asterisk-text'  },
        { title:'CLOUD_IT_DEPARTMENT_PREMIUM_INFO5', style:'service-text' },
      ],
      downloadOrPay:"PAY"
    },
    {
      typeName:'ULTIMATE',
      price:'PRICE_ULTIMATE_CLOUD_IT_DEPARTMENT',
      currency:this.currency,
      priceValue:this.isYearly? 3*((0.6*10)+(12 * 8)+(15*2)) - 22: 3*((0.6*10)+(12 * 8)+(15*2)),
      description:'CLOUD_IT_DEPARTMENT_ULTIMATE_DESCRIPTION',
      plan_desc:'',
      additionalInfo:[
        { title:'PRICING_ADDITIONAL', style:'service-text-bold'  },
        { title:'CLOUD_IT_DEPARTMENT_ULTIMATE_INFO1', style:'service-text'  },
        { title:'CLOUD_IT_DEPARTMENT_ULTIMATE_INFO3', style:'service-text' },
        { title:'CLUSTER_HOSTING_ULTIMATE_INFO4', style:'service-text third-asterisk-text'  },
        { title:'CLOUD_IT_DEPARTMENT_ULTIMATE_INFO2', style:'service-text' }
      ],
      comboboxInfo:[
        {title:'CLUSTER_NODES', value:2, step:1, minValue:2, maxValue:100},
        {title:'GB_DISK_SPACE', value:10, step:10, maxValue:1900, minValue:10,  pricePerItem:0.8  },
        {title:'GB_MEMORY', value:8, maxValue:1024, minValue:8, pricePerItem:12},
        {title:'GB_CORES', value:2, step:2, maxValue:48, minValue:2, pricePerItem:12}
      ],
      downloadOrPay:"PAY"
    }
  ]
  };

  databaseHosting={
    title:'DATABASE_HOSTING',
    type:[
      {
        typeName:'FREE',
        price:'PRICE_FREE_DATABASE_HOSTING',
        currency:this.currency,
        description:'FREE_DESCRIPTION_DATABASE_HOSTING',
        plan_desc:'',
        additionalInfo:[
          { title:'DATABASE_HOSTING_FREE_INFO1', style:'service-text'},
          { title:'DATABASE_HOSTING_FREE_INFO2', style:'service-text'},
          { title:'DATABASE_HOSTING_FREE_INFO3', style:'service-text'},
          { title:'DATABASE_HOSTING_FREE_INFO4', style:'service-text'},
          { title:'DATABASE_HOSTING_FREE_INFO5', style:'service-text'}
        ],
        downloadOrPay:"PAY"
    },
    {
      typeName:'PREMIUM',
      price:'PRICE_PREMIUM_DATABASE_HOSTING',
      priceValue:'',
      currency:this.currency,
      description:'PREMIUM_DESCRIPTION_DATABASE_HOSTING',
      plan_desc:'',
      additionalInfo:[
        { title:'DATABASE_HOSTING_PREMIUM_INFO1', style:'service-text'},
        { title:'DATABASE_HOSTING_PREMIUM_INFO2', style:'service-text'},
        { title:'DATABASE_HOSTING_PREMIUM_INFO3', style:'service-text'},
        { title:'DATABASE_HOSTING_PREMIUM_INFO4', style:'service-text'},
        { title:'DATABASE_HOSTING_PREMIUM_INFO5', style:'service-text'},
      ],
      downloadOrPay:"PAY"
    },
    {
      typeName:'ULTIMATE',
      price:'PRICE_ULTIMATE_DATABASE_HOSTING',
      priceValue:'',
      currency:this.currency,
      description:'ULTIMATE_DESCRIPTION_DATABASE_HOSTING',
      plan_desc:'',
      additionalInfo:[
        { title:'DATABASE_HOSTING_ULTIMATE_INFO1', style:'service-text'},
        { title:'DATABASE_HOSTING_ULTIMATE_INFO2', style:'service-text'},
        { title:'DATABASE_HOSTING_ULTIMATE_INFO3', style:'service-text'},
        { title:'DATABASE_HOSTING_ULTIMATE_INFO4', style:'service-text'},
        { title:'DATABASE_HOSTING_ULTIMATE_INFO5', style:'service-text'},
      ],
      comboboxInfo:[
        {title:'GB_DISK_SPACE', value:1},
        {title:'GB_MEMORY', value:1},
        {title:'GB_CORES', value:1}
      ],
      downloadOrPay:"PAY"
    }
  ]
  };
  clusterHosting={
    title:'CLUSTER_HOSTING',
    type:[
      {
        typeName:'FREE',
        price:'PRICE_FREE_CLUSTER_HOSTING',
        currency:this.currency,
        description:'FREE_DESCRIPTION_CLUSTER_HOSTING',
        plan_desc:'',
        additionalInfo:[
          { title:'CLUSTER_HOSTING_FREE_INFO1', style:'service-text'},
          { title:'CLUSTER_HOSTING_FREE_INFO2', style:'service-text'},
          { title:'CLUSTER_HOSTING_FREE_INFO3', style:'service-text'},
          { title:'CLUSTER_HOSTING_ULTIMATE_INFO3', style:'service-text'},
        ],
        downloadOrPay:"PAY",
        dbOptions:[
          'MySql 8.4.4 LTS',
          'MariaDB 11.4.5'
        ],
        currentDb:'MySql 8.4.4 LTS',
    },
    {
      typeName:'PREMIUM',
      price:'PRICE_PREMIUM_CLUSTER_HOSTING',
      priceYearly:'PRICE_PREMIUM_CLUSTER_HOSTING_YEARLY',
      priceValue:69,
      fullPriceYearly:69*12,
      sparedPriceYearly:(69*12)-((69*12)*0.25),
      currency:this.currency,
      description:'PREMIUM_DESCRIPTION_CLUSTER_HOSTING',
      plan_desc:'',
      additionalInfo:[
        { title:'PRICING_ADDITIONAL', style:'service-text-bold' },
        { title:'CLUSTER_HOSTING_PREMIUM_INFO2', style:'service-text asterisk-text'},
        { title:'CLUSTER_HOSTING_PREMIUM_INFO3', style:'service-text double-asterisk-text'},
        { title:'CLUSTER_HOSTING_ULTIMATE_INFO2', style:'service-text'},
        { title:'CLUSTER_HOSTING_PREMIUM_INFO4', style:'service-text third-asterisk-text'},
      ],
      downloadOrPay:"PAY",
      dbOptions:[
        'MySql 8.4.4 LTS',
        'MariaDB 11.4.5'
      ],
      currentDb:'MySql 8.4.4 LTS',
    },
    {
      typeName:'ULTIMATE',
      price:'PRICE_ULTIMATE_CLUSTER_HOSTING',
      priceYearly:'PRICE_ULTIMATE_CLUSTER_HOSTING_YEARLY',
      // priceValue: numberOfInstances * ((0.6 * gbPlattenplatz) + (12 * gbMemory) + (15*vCPUs)),
      fullPriceYearly:(1*((0.6*10)+(12 * 8)+(15*2)))*12,
      sparedPriceYearly:((1*((0.6*10)+(12 * 8)+(15*2)))*12)-(((1*((0.6*10)+(12 * 8)+(15*2)))*12)*0.25),
      priceValue: 1*((0.6*10)+(12 * 8)+(15*2)),
      currency:this.currency,
      description:'ULTIMATE_DESCRIPTION_CLUSTER_HOSTING',
      plan_desc:'',
      additionalInfo:[
        { title:'PRICING_ADDITIONAL', style:'service-text-bold' },
        { title:'CLUSTER_HOSTING_ULTIMATE_INFO4', style:'service-text'},
        { title:'CLUSTER_HOSTING_ULTIMATE_INFO5', style:'service-text'},
      ],
      dbOptions:[
        'MySql 8.4.4 LTS',
        'MariaDB 11.4.5'
      ],
      currentDb:'MySql 8.4.4 LTS',
      comboboxInfo:[
        {title:'GB_DISK_SPACE', value:10, step:10, maxValue:500, minValue:10,  pricePerItem:0.8  },
        {title:'GB_MEMORY', value:8, maxValue:128, minValue:4, pricePerItem:12},
        {title:'GB_CORES', value:2, step:2, maxValue:32, minValue:2, pricePerItem:12}
      ],
      downloadOrPay:"PAY"
    }
  ]};
  migration={
    title:'MIGRATION',
    type:[
      {
        typeName:'FREE',
        price:'PRICE_FREE_MIGRATION',
        currency:this.currency,
        description:'FREE_DESCRIPTION_MIGRATION',
        plan_desc:'',
        additionalInfo:[
          { title:'MIGRATION_FREE_INFO1', style:'service-text'},
          { title:'MIGRATION_FREE_INFO2', style:'service-text'},
          { title:'MIGRATION_FREE_INFO3', style:'service-text'},
          { title:'MIGRATION_FREE_INFO4', style:'service-text'}
        ],
        downloadOrPay:"PAY"
    },
    {
      typeName:'PREMIUM',
      price:'PRICE_PREMIUM_MIGRATION',
      priceYearly:'PRICE_PREMIUM_MIGRATION_YEARLY',
      priceValue:129,
      fullPriceYearly:129*12,
      sparedPriceYearly:(129*12)-((129*12)*0.25),
      currency:this.currency,
      description:'PREMIUM_DESCRIPTION_MIGRATION',
      plan_desc:'',
      additionalInfo:[
        { title:'MIGRATION_PREMIUM_INFO1', style:'service-text'},
        { title:'MIGRATION_PREMIUM_INFO2', style:'service-text'},
        { title:'MIGRATION_PREMIUM_INFO3', style:'service-text'},
        { title:'MIGRATION_PREMIUM_INFO4', style:'service-text'}
      ],
      downloadOrPay:"PAY"
    },
    {
      typeName:'ULTIMATE',
      price:'PRICE_ULTIMATE_MIGRATION',
      priceYearly:'PRICE_ULTIMATE_MIGRATION_YEARLY',
      // priceValue: numberOfInstances * ((0.6 * gbPlattenplatz) + (12 * gbMemory) + (15*vCPUs)),
      fullPriceYearly:99*12,
      sparedPriceYearly:(99*12)-((99*12)*0.25),
      priceValue: 99,
      currency:this.currency,
      description:'ULTIMATE_DESCRIPTION_MIGRATION',
      plan_desc:'',
      additionalInfo:[
        { title:'MIGRATION_ULTIMATE_INFO1', style:'service-text'},
        { title:'MIGRATION_ULTIMATE_INFO2', style:'service-text'},
        { title:'MIGRATION_ULTIMATE_INFO3', style:'service-text'},
        { title:'MIGRATION_ULTIMATE_INFO4', style:'service-text'}
      ],
      comboboxInfo:[
        {title:'GB_DISK_SPACE', value:1},
        {title:'GB_MEMORY', value:1},
        {title:'GB_CORES', value:1}
      ],
      downloadOrPay:"PAY"
    }
  ]};
  syncApi={
    title:'PRODUCT_SYNC_API',
    type:[
      {
        typeName:'JAVA_SCRIPT',
        price:'FREE_CONSTANT',
        currency:this.currency,
        description:'JAVA_SCRIPT_DESCRIPTION',
        plan_desc:'',
        additionalInfo:[
          { title:'JAVA_SCRIPT_FREE_INFO1', style:'service-text'},
          { title:'JAVA_SCRIPT_FREE_INFO2', style:'service-text'},
          { title:'JAVA_SCRIPT_FREE_INFO3', style:'service-text'},
          { title:'JAVA_SCRIPT_FREE_INFO4', style:'service-text'},
          { title:'JAVA_SCRIPT_FREE_INFO5', style:'service-text'},
          { title:'JAVA_SCRIPT_FREE_INFO6', style:'service-text'}
        ],
        downloadOrPay:"DOWNLOAD",
        redirectDownload:'downloads/se2sync-api'
    },
    {
      typeName:'JAVA',
      price:'FREE_CONSTANT',
      currency:this.currency,
      description:'JAVA_DESCRIPTION',
      plan_desc:'',
      additionalInfo:[
        { title:'JAVA_FREE_INFO1', style:'service-text'},
        { title:'JAVA_FREE_INFO2',style:'service-text'},
        { title:'JAVA_FREE_INFO3',style:'service-text'},
        { title:'JAVA_FREE_INFO4', style:'service-text'},
        { title:'JAVA_FREE_INFO5',style:'service-text'},
        { title:'JAVA_FREE_INFO6',style:'service-text'}
      ],
      downloadOrPay:"DOWNLOAD",
      redirectDownload:'downloads/se2sync-api'
    },
    {
      typeName:'JAVA_PRO',
      price:'JAVA_PRO_PRICE',
      priceValue:69,
      currency:this.currency,
      description:'JAVA_PRO_DESCRIPTION',
      plan_desc:'',
      additionalInfo:[
        { title:'JAVA_PRO_INFO1', style:'service-text'},
        { title:'JAVA_PRO_INFO2', style:'service-text'},
        { title:'JAVA_PRO_INFO3',style:'service-text'},
        { title:'JAVA_PRO_INFO4', style:'service-text'},
        { title:'JAVA_PRO_INFO5',style:'service-text'},
        { title:'JAVA_PRO_INFO6',style:'service-text'}
      ],
      downloadOrPay:"PAY"
    }
  ]};
  constructor(
    private route:ActivatedRoute,
    public translateService: TranslateService,
    public router:Router,
    public fullModeService:FullModeService,
    private authService:AuthService,
    public lxcService:LxcContainerService,
    private snackBar: MatSnackBar,
    private stripePaymentService: StripePaymentService,
    private serversService: ServersService
  ) { 
    this.nav = this.router.getCurrentNavigation();
    console.log('this.nav', this.nav)
  }

  ngOnInit(): void {
    this.route.params.subscribe((params)=>{
      let type = params['type'];
      console.log('type', type)
      this.currentPlanType = type;
      if(type=='cloud-it-department'){
        this.titleSectionProp.title=this.cloudITDepartment.title;
        this.appPrice = this.cloudITDepartment;
      }else if(type=='database'){
        this.titleSectionProp.title=this.databaseHosting.title;
        this.appPrice = this.databaseHosting;
      }else if(type=='cluster-hosting'){
        this.titleSectionProp.title=this.clusterHosting.title;
        this.appPrice = this.clusterHosting;
      }else if(type=='se2sync-api'){
        this.titleSectionProp.title=this.syncApi.title;
        this.appPrice = this.syncApi;
      }else{
        this.titleSectionProp.title = 'MIGRATION'
        this.titleSectionProp.title=this.migration.title;
        this.appPrice = this.migration;
      }
    })
    let appInfo = this.nav?.extras?.state?.['appInfo'];
    let type = this.nav?.extras?.state?.['type'];
    let subType = this.nav?.extras?.state?.['subscriptionType'];
    console.log('appInfo', appInfo)
    if(appInfo && type === 'CREATE_LXC'){
      this.createLxcWithRedirect(appInfo, subType);
    }else if(appInfo && type === 'STRIPE_PAYMENT'){
      this.initiateStripePayment(appInfo);
    }
    this.getFreeServer();
  }

  payForProduct(appInfo:any){
    if(appInfo.typeName==='FREE'){
      if(!this.canOrderFreeServer) return;
      this.createLxcWithRedirect(appInfo, appInfo.typeName);
      return;
    }

    if(this.currentPlanType === 'cluster-hosting'){
      this.initiateStripePayment(appInfo);
    }else{
      const lang = "de";
      window.location.href = `https://m.gofo.rest/#/payment?amount=${appInfo.price}&evId=-1&curr=${this.currency}&lang=${lang}&address=true`;
    }
  }
  getFreeServer(){
    const token = this.authService.getToken();
    if(!token){
      return;
    }
    this.serversService.getFreeServer(token).subscribe((res)=>{
      console.log('getFreeServer', res)
      this.canOrderFree.next(res.canOrderFree);
      this.canOrderFreeServer = res.canOrderFree;

    })
  }

  private initiateStripePayment(appInfo: any): void {
    const token = this.authService.getToken();
    if(!token){
      localStorage.setItem('postLoginAction', JSON.stringify({
        type: 'STRIPE_PAYMENT',
        path: this.router.url,
        appInfo
      }));
      this.router.navigate(['/login']);
      return;
    }

    this.isLoading = true;

    const lang = localStorage.getItem('language') || this.translateService.currentLang || 'de';
    const planId = `CLUSTER_HOSTING_${appInfo.typeName}`;
    const amountCents = Math.round((Number(appInfo.priceValue) || 0) * 100);

    const request: StripeCheckoutRequest = {
      planId,
      amountCents,
      billingInterval: this.isYearly ? 'year' : 'month',
      currency: this.currency,
      lang,

      host: this.stripePaymentService.getHost(),
    };

    if (appInfo.typeName === 'ULTIMATE' && appInfo.comboboxInfo) {
      const disk = appInfo.comboboxInfo.find((c: any) => c.title === 'GB_DISK_SPACE')?.value;
      const memory = appInfo.comboboxInfo.find((c: any) => c.title === 'GB_MEMORY')?.value;
      const cores = appInfo.comboboxInfo.find((c: any) => c.title === 'GB_CORES')?.value;
      if (disk != null)   request.diskGb   = disk;
      if (memory != null) request.memoryGb = memory;
      if (cores != null)  request.cores    = cores;

    }

    console.log('[PlanComponent] Initiating Stripe checkout', {
      planId: request.planId,
      amountCents: request.amountCents,
      billingInterval: request.billingInterval,
      ...(appInfo.typeName === 'ULTIMATE' && {
        diskGb: request.diskGb,
        memoryGb: request.memoryGb,
        cores: request.cores,
      }),
      host: request.host,
    });
    console.log('[PlanComponent] Stripe checkout request', request)

    this.stripePaymentService.createCheckoutSession(request, token).subscribe({
      next: (response) => {
        this.isLoading = false;
        localStorage.setItem('stripeLastCheckout', JSON.stringify({
          planId: request.planId,
          createdAt: new Date().toISOString(),
        }));
        const redirectUrl = response.checkoutUrl || response.url || '';
        this.stripePaymentService.redirectToCheckout(redirectUrl);
      },
      error: (err) => {
        this.isLoading = false;
        console.error('[PlanComponent] Stripe checkout request failed', {
          status: err?.status,
          message: err?.message,
          planId: request.planId,
        });
        if(err?.status === 429){
          this.showRateLimitToast();
        } else {
          this.showPaymentErrorToast();
        }
      }
    });
  }
  redirectDownload(appPrice:any){
    if(appPrice.typeName=='JAVA_SCRIPT' || appPrice.typeName=='JAVA'){
      this.router.navigate([appPrice.redirectDownload], { queryParams: { appType: appPrice.typeName }})
    }else{
      this.router.navigate([appPrice.redirectDownload])
    }
  }
  increase(combobox:any, item:any){
    if (combobox.title === 'GB_MEMORY') {
      combobox.value = combobox.value < 8 ? 8 : combobox.value * 2;
      if(combobox.value>=combobox.maxValue){
        combobox.value = combobox.maxValue
      }
    } else if(combobox.title ==='GB_CORES'){
      if(combobox.value<32){
        combobox.value *= combobox.step
      }else if(combobox.value==32){
        combobox.value+=16
      }else{
        combobox.value=48
      }
    }else if(combobox.title==='GB_DISK_SPACE'){
      combobox.value += combobox.step || 1;
      if(combobox.value>=combobox.maxValue){

      }
    }
    else {
      combobox.value += combobox.step || 1;
      if(combobox.value >= combobox.maxValue){
        combobox.value = combobox.maxValue
      }
    }
    this.calculatePrice(combobox, item)
  }
  decrease(combobox:any, item:any){
    if (combobox.title === 'GB_MEMORY') {
      if (combobox.value > 8) {
        combobox.value /= 2;
      } else {
        combobox.value = 8;
      }
    }else if(combobox.title ==='GB_CORES'){
      const minValue = combobox.minValue ?? 2;
      let nextValue: number;
      if(combobox.value === 48){
        nextValue = combobox.value - 16;
      }else{
        nextValue = combobox.value / combobox.step;
      }
      if (nextValue < minValue) {
        return;
      }
      combobox.value = nextValue;
    } else {
      const nextValue = combobox.value - (combobox.step || combobox.minValue);
      if (nextValue < combobox.minValue) {
        return;
      }
      combobox.value = nextValue;
    }
    this.calculatePrice(combobox, item)
  }
  calculatePrice(combobox:any, item:any){
    let comboboxInfo = item.comboboxInfo
    let numberOfInstances = comboboxInfo.find((item:any)=> item.title === 'CLUSTER_NODES')?.value||1;
    let gbPlattenplatz = comboboxInfo.find((item:any)=> item.title === 'GB_DISK_SPACE')?.value;
    let gbMemory = comboboxInfo.find((item:any) => item.title === 'GB_MEMORY')?.value;
    let vCPUs = comboboxInfo.find((item:any) => item.title === 'GB_CORES')?.value;
    // Number of Instances * (0,6 * GB Plattenplatz + 12 * GB Memory + 16 * vCPUs)
    let currentPrice = numberOfInstances * ((0.6 * gbPlattenplatz) + (12 * gbMemory) + (15*vCPUs))
    item.priceValue = currentPrice.toFixed(0)
    item.fullPriceYearly = currentPrice * 12
    item.sparedPriceYearly = item.fullPriceYearly - (item.fullPriceYearly * 0.25)

  }

  onInputChange(event: any, combobox: any, item:any) {
    const newValue = Number(event.target.value);
    const minValue = combobox.minValue ?? 0;

    if (combobox.title === 'GB_CORES' && (Number.isNaN(newValue) || newValue < minValue)) {
      event.target.value = combobox.value;
      return;
    }

    if (newValue < minValue) {
        combobox.value = minValue;
    } else if (combobox.maxValue && newValue > combobox.maxValue) {
        combobox.value = combobox.maxValue;
    } else {
        combobox.value = newValue;
    }
    this.calculatePrice(combobox, item)
  }
  changeDb(item:any, db:string){
    item.currentDb = db
  }


  createLxcWithRedirect(appInfo:any, subscriptionType:string){
    let params  = this.extractResources(appInfo.additionalInfo, subscriptionType);
    // let params = {disk: 5,cpu: 1,memory: "4GiB"}
    // let params = {"disk": 7,"cpu": 1,"memory": "6GiB"}
    let token = this.authService.getToken();
    if(!token){
      localStorage.setItem('postLoginAction', JSON.stringify({
        type: 'CREATE_LXC',
        path:this.router.url,
        appInfo,
        subscriptionType
      }));
      this.router.navigate(['/login']);
      return;
    }
    this.showToast('', 5000)
    this.lxcService.activateFreeContainer(token).subscribe(
      {
      next: (res) => {
        console.log('LXC created:', res);
        window.location.href = 'se2-tech-creator://payment-info'
        if(subscriptionType=='FREE'){
          this.getFreeServer();
        }
      },
      error: (err) => {
        console.error('Error creating LXC:', err);
        if(subscriptionType=='FREE'){
          this.getFreeServer();
        }
        this.showErrorToast('CREATE_LXC_ERROR', 'Error creating LXC. Please try again.');
      }
    }
  );
  }
  private showErrorToast(i18nKey: string, fallback: string): void {
    this.translateService.get(i18nKey).subscribe({
      next: (translated: string) => {
        const message = translated === i18nKey ? fallback : translated;
        this.snackBar.open(message, 'Close', {
          duration: 8000,
          panelClass: ['my-custom-snackbar', 'snackbar-error'],
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
        });
      },
      error: () => {
        this.snackBar.open(fallback, 'Close', {
          duration: 8000,
          panelClass: ['my-custom-snackbar', 'snackbar-error'],
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
        });
      }
    });
  }
  extractResources(additionalInfo: { title: string; style: string }[], type:string) {
    console.log('additionalInfo', additionalInfo)
    const result = { disk: 0, memory: "", cpu: 0, type:type };
    const keys = additionalInfo.map(item => item.title);

    this.translateService.get(keys).subscribe(translations => {
      for (const key of keys) {
        const text: string = translations[key];
        if (!text) continue;

        const storageMatch = text.match(/(\d+)\s*GB\s*(storage|speicherplatz)/i);
        if (storageMatch) {
          console.log('storageMatch', storageMatch)
          result.disk += parseInt(storageMatch[1], 10);
        }

        // Extract traffic from text like "1 GB traffic inklusive"
        // const trafficMatch = text.match(/(\d+)\s*GB\s*traffic/i);
        // if (trafficMatch) {
        //   result.memory += parseInt(trafficMatch[1], 10);
        // }

        const cpuMatch = text.match(/(\d+)\s*CPU/i);
        if (cpuMatch) {
          console.log(cpuMatch)
          result.cpu += parseInt(cpuMatch[1], 10);
        }else{
          result.cpu = 1;
        }

        result.memory = "1GiB"
      }
    })
    console.log('result', result)
    return result
  }

  showToast(action = '', duration = 5000) {
    let message = "RETURN_ORDER_MESSAGE"
    this.translateService.get(message).subscribe((translatedMessage: string) => {
      this.snackBar.open(translatedMessage, action, {
        duration,
        panelClass: ['my-custom-snackbar'],
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
      });
    });
  }

  private showPaymentErrorToast(): void {
    this.openSnackbar('PAYMENT_ERROR_MESSAGE',
      'Payment could not be initiated. Please try again or contact support.',
      ['my-custom-snackbar', 'snackbar-error'], 8000);
  }

  private showRateLimitToast(): void {
    this.openSnackbar('PAYMENT_RATE_LIMIT_MESSAGE',
      'Too many payment requests. Please wait a moment and try again.',
      ['my-custom-snackbar', 'snackbar-warning'], 8000);
  }

  private openSnackbar(i18nKey: string, fallback: string, panelClass: string[], duration: number): void {
    this.translateService.get(i18nKey).subscribe({
      next: (translated: string) => {
        const message = translated === i18nKey ? fallback : translated;
        this.snackBar.open(message, 'Close', {
          duration,
          panelClass,
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
        });
      },
      error: () => {
        this.snackBar.open(fallback, 'Close', {
          duration,
          panelClass,
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
        });
      }
    });
  }
  onMonthlyPlanTypeChange(event: any){
    this.isYearly = false;
  }
  onYearlyPlanTypeChange(event: any){
    this.isYearly = true;
  }

}
